import classNames from 'classnames';
import React, {Component, Fragment} from 'react';
import './DashboardReports.scss';
import {connect} from "react-redux";
import moment from 'moment';

class DashboardRiskAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasNextReportUpdated: false,
      popupPosition: {},
      isOpened: false
    };
  }

  // ------------
  // Getters
  // ------------

  get riskAlertsSorted() {
    return this.props.reports && this.props.reports.sort((a, b) => {
      return (new Date(a.observationDate)).getTime() - (new Date(b.observationDate)).getTime()
    })
  }

  get isOpened() {
    if(this.props.enableOpen) {
      return this.state.isOpened
    }
    return true
  }

  riskAlertsObservations(riskAlert) {
    return riskAlert.observations.filter(ob =>
      ob.rating <= this.props.settings.riskAlert ||
      !!riskAlert.report.settings && !!riskAlert.report.settings.riskAlert && ob.rating <= riskAlert.report.settings.riskAlert)
  }

  setPopupPosition(key, e) {
    this.setState({
      popupPosition: {
        ...this.state.popupPosition,
        [key]: {
          top: e.clientY,
          left: e.clientX
        }
      }
    })
  }

  // ------------
  // Render
  // ------------
  render() {
    return (
      <div
        style={{flex: this.props.colSpan}}
        className={classNames('card', 'dashboard-reports', 'has-warnings', {emmbeded: this.props.emmbeded})}
      >
        <div className="header" onClick={() => this.setState({isOpened: !this.state.isOpened})}>
          <i className={`fa fa-${this.props.icon}`}/>
          <span>
            {this.props.title}
          </span>

          {this.props.enableOpen && !this.isOpened && <i className={`fa fa-chevron-down`}/>}
          {this.props.enableOpen && this.isOpened && <i className={`fa fa-chevron-up`}/>}
        </div>
        {this.riskAlertsSorted && this.isOpened &&
        this.riskAlertsSorted.length ? (
          <div className="risk-alerts">
            <table className="table table-small layout-auto ">
              <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Observation</th>
                <th>Score</th>
              </tr>
              </thead>
              <tbody>
              {this.props.reports.map(r => (
                <Fragment key={r.guid}>
                  {r.oit ? (
                    <tr className="oit-name">
                      <td colSpan={4}><b>{r.oit && r.oit.firstName} {r.oit && r.oit.lastName}</b></td>
                    </tr>
                  ) : null}
                  {this.riskAlertsObservations(r).map(ob => (
                    <tr key={`${r.guid}${ob.prompt}`}
                        onMouseEnter={(e) => this.setPopupPosition(`${r.guid}${ob.prompt}`, e)}>
                      <td className="risk-alert-field">
                        <span style={{whiteSpace: 'nowrap'}}>{moment(r.observationDate).format('MMM D, YYYY')}</span>
                        {ob.comment
                        && this.state.popupPosition[`${r.guid}${ob.prompt}`]
                        && <div className="rating-comment" style={{
                          top: this.state.popupPosition[`${r.guid}${ob.prompt}`].top + 'px',
                          left: this.state.popupPosition[`${r.guid}${ob.prompt}`].left + 'px'
                        }}>{ob.comment}</div>}

                      </td>
                      <td>{r.report.form.type}</td>
                      <td>{ob.prompt}</td>
                      <td>
                        {ob.rating}
                      </td>
                    </tr>
                  ))}
                </Fragment>
              ))}
              </tbody>
            </table>
          </div>
        ) : null}
        {!this.props.reports.length && (
          <div className="no-reports">{this.props.noReportsMessage}</div>
        )}
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  userContext: state.common.userContext,
  settings: state.departmentSettings.settings
});

export default connect(mapStateToProps)(DashboardRiskAlerts);
